export const customerTypes = [
  'prospect',
  'new customer',
  'existing customer',
] as const
